import React, { Component } from 'react';
import { Modal, Grid, Row, Col, Form, FormGroup, ControlLabel, FormControl, Checkbox, HelpBlock, ButtonToolbar, Button } from 'react-bootstrap';

import { TableButton } from '../../../TableButton';

export class FlatFareRules extends Component {
    constructor(props) {
        super(props);

        this.state = {
            model: this.props.model,
            priceInputError: null
        };
    }

    // ----------------------

    onAddRule() {
        const { model } = this.state;

        model.rules.push({
            price: "",
            perLine: false
        });

        this.setState({
            model: model
        });
    }

    onRemoveRule(rule) {
        const { model } = this.state;

        model.rules = model.rules.filter(modelRule => rule !== modelRule);

        this.setState({
            model: model
        });
    }

    onChangeValue(e, rule, property) {
        const { model } = this.state;

        const modelRule = model.rules.find(modelRule => modelRule === rule);
        if (undefined === modelRule) {
            return;
        }

        modelRule[property] = e.target.value;

        this.setState({
            model: model
        });
    }

    onCheckValue(e, rule, property) {
        const { model } = this.state;

        const modelRule = model.rules.find(modelRule => modelRule === rule);
        if (undefined === modelRule) {
            return;
        }

        modelRule[property] = e.target.checked;

        this.setState({
            model: model
        });
    }

    onSave() {
        const { model } = this.state;

        if (this.isValidInput()) {
            this.props.onSave(model);
        }
    }

    // ----------------------

    isValidInput() {
        let errors = 0;
        let priceInputError = null;

        const { model } = this.state;

        if (undefined === model.rules) {
            model.rules = [];
        }

        if (model.rules.reduce((output, rule) => output || undefined === rule.price || null === rule.price || "" === rule.price, false)) {
            priceInputError = 'error';
            errors++;
        }

        this.setState({
            priceInputError: priceInputError,
        });

        return 0 === errors;
    }

    // ----------------------

    renderEmptyColumn() {
        return <Col className="padding-0" xs={1}></Col>;
    }

    renderRemoveIcon(rule, isEditable) {
        if (isEditable) {
            return (
                <Col className="padding-0 text-align-center" xs={1}>
                    <TableButton icon="icon-error"
                        title="Remover Regra"
                        onClick={() => this.onRemoveRule(rule)} />
                </Col>
            );
        }

        return null;
    }

    renderHelpBlock(inputError, message) {
        if (null === inputError) {
            return null;
        }

        return (
            <Row>
                <Col className="padding-0" xs={12}>
                    <FormGroup controlId="formPrice" validationState={inputError}>
                        <HelpBlock>{message}</HelpBlock>
                    </FormGroup>
                </Col>
            </Row>
        );
    }

    renderPriceFormControl(rule, isEditable) {
        if (isEditable) {
            return (
                <FormControl
                    type="number"
                    value={rule.price}
                    placeholder="Introduza o Preço"
                    onChange={(a) => this.onChangeValue(a, rule, "price")}
                />
            );
        }

        return (
            <div>
                {rule.price}
            </div>
        );
    }

    renderPerLineFormControl(rule, isEditable) {
        return (
            <Checkbox className="form-checkbox"
                defaultChecked={rule.perLine}
                disabled={!isEditable}
                onChange={(e) => this.onCheckValue(e, rule, "perLine")}>
                &nbsp;
            </Checkbox>
        );
    }

    renderRules(model, isEditable) {
        const { priceInputError } = this.state;

        if (undefined === model.rules) {
            model.rules = [];
        }

        return (
            <Form>
                <Grid fluid>
                    <Row>
                        <Col className="padding-0" xs={5}>
                            <FormGroup controlId="formPrice" validationState={priceInputError}>
                                <ControlLabel>Preço</ControlLabel>
                            </FormGroup>
                        </Col>

                        {this.renderEmptyColumn()}

                        <Col className="padding-0" xs={5}>
                            <FormGroup controlId="formPerLine">
                                <ControlLabel>Por Linha</ControlLabel>
                            </FormGroup>
                        </Col>

                        {this.renderEmptyColumn()}
                    </Row>

                    {
                        model.rules.map((rule, idx) =>
                            <Row key={`row-${idx}`}>
                                <Col className="padding-0" xs={5}>
                                    <FormGroup controlId="formPrice" validationState={priceInputError}>
                                        {this.renderPriceFormControl(rule, isEditable)}
                                    </FormGroup>
                                </Col>

                                {this.renderEmptyColumn()}

                                <Col className="padding-0" xs={5}>
                                    <FormGroup controlId="formPerLine">
                                        {this.renderPerLineFormControl(rule, isEditable)}
                                    </FormGroup>
                                </Col>

                                {this.renderRemoveIcon(rule, isEditable)}
                            </Row>
                        )
                    }

                    {this.renderHelpBlock(priceInputError, "O Preço tem de estar definido para todas as regras")}
                </Grid>
            </Form>
        );
    }

    renderButtons(isEditable) {
        if (isEditable) {
            return (
                <ButtonToolbar>
                    <Button onClick={() => this.onSave()}> GUARDAR ALTERAÇÕES </Button>
                    <Button onClick={() => this.props.onExit()}> CANCELAR </Button>
                    <Button className="pull-right" onClick={() => this.onAddRule()}> ADICIONAR REGRA </Button>
                </ButtonToolbar>
            );
        }

        return (
            <ButtonToolbar>
                <Button onClick={() => this.props.onExit()}> FECHAR </Button>
            </ButtonToolbar>
        );
    }

    render() {
        const { model } = this.state;

        if (null === model || undefined === model) {
            return null;
        }

        const { isEditable } = this.props;

        return (
            <Modal show={true} bsSize="large">
                <Modal.Header>
                    <Modal.Title>Regras do Produto {model.name} - Preço Único</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.renderRules(model, isEditable)}

                    {this.renderButtons(isEditable)}
                </Modal.Body>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/fareProducts/rules/FlatFareRules.js